(function () {
  angular.module("akitabox.ui.dialogs.inspectionProgram.reactivate", [
    "akitabox.core.constants",
    "akitabox.core.services.inspectionProgram",
    "akitabox.core.toast",
  ]);
})();
